import * as React from "react";

import { SoccerLive, SoccerPreLive } from "./Soccer";
import { TennisLive, TennisPreLive } from "./Tennis";

enum MainSportTypes {
    TENNIS = "tennis",
    SOCCER = "soccer"
}

interface Props {
    scoreCenterData: any;
    lang: string;
}

function ScoreCenter({ scoreCenterData, lang }: Props): JSX.Element {
    let safeIsLive = scoreCenterData.isLive;
    if (scoreCenterData.isLive === undefined) {
        safeIsLive = scoreCenterData.live;
    }

    let safeIsEventEnded = scoreCenterData.event.isEnded;
    if (scoreCenterData.event.isEnded === undefined) {
        safeIsEventEnded = scoreCenterData.event.ended;
    }

    switch (scoreCenterData.sportId) {
        case MainSportTypes.TENNIS: {
            return safeIsLive || safeIsEventEnded ? (
                <TennisLive sportEvent={scoreCenterData} lang={lang} />
            ) : (
                <TennisPreLive sportEvent={scoreCenterData} />
            );
        }

        case MainSportTypes.SOCCER: {
            return safeIsLive || safeIsEventEnded ? (
                <SoccerLive sportEvent={scoreCenterData} lang={lang} />
            ) : (
                <SoccerPreLive sportEvent={scoreCenterData} />
            );
        }

        default: {
            return <div />;
        }
    }
}

export default ScoreCenter;
